import { render } from "./VODCardView.vue?vue&type=template&id=03f3c796&scoped=true"
import script from "./VODCardView.vue?vue&type=script&lang=js"
export * from "./VODCardView.vue?vue&type=script&lang=js"

import "./VODCardView.vue?vue&type=style&index=0&id=03f3c796&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f3c796"],['__file',"src/components/ui/VODCardView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03f3c796"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03f3c796', __exports__)) {
    api.reload('03f3c796', __exports__)
  }
  
  module.hot.accept("./VODCardView.vue?vue&type=template&id=03f3c796&scoped=true", () => {
    api.rerender('03f3c796', render)
  })

}


export default __exports__